import { createContext, useCallback, useContext, useMemo, useState } from "react";

const NO_OP_ROW_ACTIONS = {
  openRowActionModal: () => {},
  closeRowActionModal: () => {},
};

// Two contexts on purpose: action cells only read the dispatchers, whose identity
// never changes, so opening a modal re-renders the modal host and nothing else.
const PricerRowActionsContext = createContext(NO_OP_ROW_ACTIONS);
const PricerRowActionModalContext = createContext(null);

export const usePricerRowActions = () => useContext(PricerRowActionsContext);

export const usePricerRowActionModal = () =>
  useContext(PricerRowActionModalContext);

const PricerRowActionsProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);

  const openRowActionModal = useCallback((type, payload) => {
    setActiveModal({ type, ...payload });
  }, []);

  const closeRowActionModal = useCallback(() => setActiveModal(null), []);

  const rowActions = useMemo(
    () => ({ openRowActionModal, closeRowActionModal }),
    [openRowActionModal, closeRowActionModal]
  );

  return (
    <PricerRowActionsContext.Provider value={rowActions}>
      <PricerRowActionModalContext.Provider value={activeModal}>
        {children}
      </PricerRowActionModalContext.Provider>
    </PricerRowActionsContext.Provider>
  );
};

export default PricerRowActionsProvider;
